module.exports = __webpack_public_path__ + "static/media/MORE.2ded7304.png";